module.exports = __webpack_public_path__ + "static/media/gallery-2.9d341fed.png";